import moment from 'moment/min/moment-with-locales';
import { useTranslation } from 'react-i18next';
import { DATE_FORMAT_DD_MMM_YYYY } from '@/helpers/common';
import { prettyFloatMoney } from '@/helpers/utils';
import s from './index.module.scss';

export const ExampleList = ({ data }) => {
  const { t } = useTranslation('loan_terms');
  return (
    <div className={s.example_list}>
      <div className={s.example_list__list}>
        {data.list.map((item, idx) => (
          <div className={s.example_list__card} key={idx}>
            <div className={s.example_list__card__info}>
              <div>
                №{idx + 1}. {moment(item.date).format(DATE_FORMAT_DD_MMM_YYYY)}
              </div>

              <div className={s.example_list__card__row}>
                <div className="c-grey f-14 f-400">
                  {t('v2.detail.list_flat_fee')}
                </div>
                <div className="f-16 f-500">
                  {item.fee ? prettyFloatMoney(item.fee) : '-'}
                </div>
              </div>

              <div className={s.example_list__card__row}>
                <div className="c-grey f-14 f-400">
                  {t('v2.detail.list_principal')}
                </div>
                <div className="f-16 f-500">
                  {item.principal ? prettyFloatMoney(item.principal) : '-'}
                </div>
              </div>

              <div className={s.example_list__card__row}>
                <div className="c-grey f-14 f-400">
                  {t('v2.detail.list_total')}
                </div>
                <div className="f-18 f-500">{prettyFloatMoney(item.total)}</div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className={s.example_list__summary}>
        <div className={s.example_list__summary_row}>
          <div className="f-16 f-500">{t('v2.detail.list_total')}</div>
          <div className="f-18 f-500">{prettyFloatMoney(data.total)}</div>
        </div>

        <div className={s.example_list__summary_row}>
          <div className="f-16 f-500">{t('v2.detail.list_interest')}</div>
          <div className="f-18 f-500">
            {prettyFloatMoney(data.total_interest)}
          </div>
        </div>

        <div className={s.example_list__summary_row}>
          <div className="f-16 f-500">{t('v2.detail.list_flat_fee')}</div>
          <div className="f-18 f-500">
            {prettyFloatMoney(data.total_flat_fee)}
          </div>
        </div>

        <div className={s.example_list__summary_row}>
          <div className="f-16 f-500">{t('v2.detail.list_principal')}</div>
          <div className="f-18 f-500">
            {prettyFloatMoney(data.total_principal)}
          </div>
        </div>
      </div>
    </div>
  );
};
